import { useCallback, useEffect, useMemo, useState } from "react";
import Sidebar from "../components/Sidebar";
import ESMPTable from "../components/ESMPTable";
import api from "../services/api";

export default function AdminRejectedESMPs() {
  const [search, setSearch] = useState("");
  const [esmps, setEsmps] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRejected = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get("/esmp/status/Rejected");
      const data = Array.isArray(res.data?.data) ? res.data.data : [];
      const normalized = data.map((item) => ({
        ...item,
        projectName: item.project_name || item.projectName || "",
        submittedBy: item.User?.name || item.submittedBy || "N/A",
      }));
      setEsmps(normalized);
    } catch (err) {
      console.error("Error fetching rejected ESMPs:", err);
      setEsmps([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRejected();
  }, [fetchRejected]);

  const filtered = useMemo(
    () =>
      esmps.filter(
        (e) =>
          (e.projectName || "").toLowerCase().includes(search.toLowerCase()) ||
          (e.district || "").toLowerCase().includes(search.toLowerCase()) ||
          (e.submittedBy || "").toLowerCase().includes(search.toLowerCase()),
      ),
    [esmps, search],
  );

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <main className="flex-1 p-6 space-y-6">
        <div className="flex justify-between items-center bg-gradient-to-r from-red-700 to-red-500 text-white p-5 rounded-xl shadow-md">
          <h2 className="text-2xl font-bold">Admin - Rejected ESMPs</h2>
          <input
            type="text"
            placeholder="Search ESMP..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="px-3 py-2 rounded text-black border focus:ring-2 focus:ring-red-600 outline-none"
          />
        </div>

        <div className="bg-white p-6 rounded-xl shadow">
          {loading ? (
            <p className="text-gray-500">Loading rejected ESMPs...</p>
          ) : (
            <ESMPTable
              data={filtered}
              emptyMessage="No rejected ESMPs."
              showReviewerComments
              showDownloadButton
            />
          )}
        </div>
      </main>
    </div>
  );
}
